<template>
  <div class="layout-container layout-column">
    <div class="section-featured-content-block" style="background-image: url(./images/watermark.png)">
      <h2 class="heading-h2 heading--separator centered">More in this section</h2>
      <slot></slot>
    </div>
  </div>
</template>